import { render, staticRenderFns } from "./murator.vue?vue&type=template&id=664f849e&"
import script from "./murator.vue?vue&type=script&lang=js&"
export * from "./murator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports